// extracted by mini-css-extract-plugin
module.exports = {"dropdownField":"LocationAndResume_dropdownField__2Vr3y"};